import type { ClassicQuiz } from "@quizshow/protocol";

export const classicModuleManifest = {
  id: "classic",
  version: 1,
  name: "Klassisches Quiz",
  capabilities: ["teams", "scoring", "lives", "buzzer", "question_timer", "submissions", "jokers"],
} as const;

export function createStarterClassicQuiz(): ClassicQuiz {
  return {
    formatVersion: 1,
    quizId: crypto.randomUUID(),
    moduleId: "classic",
    moduleVersion: 1,
    title: "Mein Classic Quiz",
    description: "Ein neues Quizshow-Studio-Quiz",
    updatedAt: new Date().toISOString(),
    mediaAssets: [],
    allowSelfTeamSelection: false,
    allowParticipantJokers: false,
    autoOpenBuzzer: false,
    scoringMode: "points",
    ranks: [
      {
        rankId: crypto.randomUUID(),
        name: "Einsteiger",
        color: "#ffffff",
        backgroundColor: "#8f1838",
        requiredProgress: 0,
      },
    ],
    jokers: [
      {
        jokerId: crypto.randomUUID(),
        name: "50:50",
        description: "Entfernt die konfigurierte Anzahl falscher Antworten.",
        color: "#ef4565",
        icon: "50",
        type: "fifty-fifty",
        startingCount: 1,
      },
    ],
    usesLives: false,
    defaultLives: 3,
    theme: {
      primaryColor: "#8f1838",
      accentColor: "#ef4565",
      backgroundColor: "#100b11",
    },
    questions: [
      {
        questionId: crypto.randomUUID(),
        prompt: "Welche Antwort ist richtig?",
        answers: [
          { optionId: crypto.randomUUID(), text: "Antwort A", isCorrect: true },
          { optionId: crypto.randomUUID(), text: "Antwort B", isCorrect: false },
          { optionId: crypto.randomUUID(), text: "Antwort C", isCorrect: false },
          { optionId: crypto.randomUUID(), text: "Antwort D", isCorrect: false },
        ],
        timerEnabled: true,
        timerSeconds: 300,
        points: 100,
        fiftyFiftyRemoveCount: 1,
        questionType: "normal",
        answerMode: "multiple-choice",
        selectionMode: "single",
        evaluationMode: "manual",
        media: {},
      },
    ],
  };
}
